import { Center, Text } from '~/commonComponents';
import { IUser } from '~/models';
import { Colors } from '~/themes/colors';
import { TNullable } from '~/types/Nullable';
import { useCompanyMatchLabel } from '../../hooks';

interface ICompanyMatchLabelProps {
  offerOwnerId: string;
  professional: TNullable<IUser>;
  hasWorkedWithDSO?: boolean;
  hasWorkedWithOffice?: boolean;
}

export const CompanyMatchLabel = ({
  offerOwnerId,
  professional,
  hasWorkedWithDSO = false,
  hasWorkedWithOffice = false,
}: ICompanyMatchLabelProps) => {
  const data = useCompanyMatchLabel({
    offerOwnerId,
    professional,
    hasWorkedWithDSO,
    hasWorkedWithOffice,
  });

  if (!data) {
    return null;
  }

  return (
    <Center
      backgroundColor={Colors.primary_100}
      borderRadius={4}
      height={20}
      paddingInline={8}
      width="fit-content"
    >
      <Text bold color={Colors.secondary_800} fontSize={13} textTransform="uppercase">
        {data.label}
      </Text>
    </Center>
  );
};
